// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__3MIrM","toggleList":"toggleList__3yvar","item":"item__2SooZ","pdpToggleButton":"pdpToggleButton__lzaYl"};